export default "__VITE_ASSET__C7Unvnn9__"